import Icon from '../components/Icon.vue'

Icon.register({
  'spell-check': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M272 256c-8.8 0-16-7.2-16-16v-224c0-8.8 7.2-16 16-16h75c42.3 0 80.9 30.6 84.7 72.7 0.2 2 0.3 5.3 0.3 7.3 0 11-4.2 27.9-9.4 37.6 14 13.1 25.4 39.2 25.4 58.4 0 1.3-0.1 3.4-0.1 4.7-2.5 43.1-41.3 75.3-84.5 75.3h-91.4zM312 56v48h40c13.2 0 24-10.8 24-24s-10.8-24-24-24h-40zM312 152v48h56c13.2 0 24-10.8 24-24s-10.8-24-24-24h-56zM155.1 22.3l68.3 213.5c0.3 1.2 0.6 3.1 0.6 4.3 0 8.8-7.2 16-16 16v0h-24.9 0c-6.7 0-13.6-5.3-15.4-11.7l-11.9-36.3h-87.4l-11.9 36.3c-1.8 6.5-8.7 11.7-15.4 11.7h0-24.9c-8.8 0-16-7.2-16-16 0-1.2 0.3-3.1 0.6-4.3l68.3-213.5c3.9-12.3 17.6-22.3 30.5-22.3h0 25.3 0c12.9 0 26.5 10 30.5 22.3zM89.4 144h45.3l-22.6-68.7zM571.4 276.5c2.6 2.6 4.7 7.7 4.7 11.3 0 3.6-2.1 8.7-4.7 11.3l-208 208.2c-2.6 2.6-7.6 4.7-11.3 4.7-3.7 0-8.7-2.1-11.3-4.7l-112-112.2c-2.6-2.6-4.7-7.6-4.7-11.3 0-3.7 2.1-8.7 4.7-11.3l45.3-45.3c2.6-2.6 7.6-4.7 11.3-4.7s8.7 2.1 11.3 4.7l55.4 55.5 151.5-151.5c2.6-2.6 7.6-4.7 11.3-4.7s8.7 2.1 11.3 4.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/spell-check.js
// module id = 1933
// module chunks = 0